import { useCallback } from "react";
import { emailDraftConfig } from "./config";
import { EmailButton } from "./EmailButton";
import type { EmailPlan } from "./intent";
import { answerEmailDocument, type EmailContextLabel } from "./sources";
import type { EmailDraftSource } from "./useEmailDraft";

interface AnswerEmailButtonProps {
  traceId: string;
  /** The answer to email; nothing is rendered without one. */
  draft?: EmailPlan["email"];
  context?: EmailContextLabel | null;
}

/** The Email control under one analyst reply. */
export function AnswerEmailButton({
  traceId,
  draft,
  context,
}: AnswerEmailButtonProps) {
  const prepare = useCallback(
    (): EmailDraftSource => ({
      document: answerEmailDocument({
        answer: draft?.answer ?? "",
        question: draft?.question,
        context,
      }),
    }),
    [draft, context],
  );
  if (!draft || !emailDraftConfig().enabled) return null;
  return (
    <div className="message-actions">
      <EmailButton traceId={traceId} kind="answer" prepare={prepare} compact />
    </div>
  );
}

export default AnswerEmailButton;
